import { render, staticRenderFns } from "./kycVerify.vue?vue&type=template&id=5bbbe1ab&scoped=true&"
import script from "./kycVerify.vue?vue&type=script&lang=js&"
export * from "./kycVerify.vue?vue&type=script&lang=js&"
import style0 from "./kycVerify.vue?vue&type=style&index=0&id=5bbbe1ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbe1ab",
  null
  
)

export default component.exports